import { categorySchema } from "@/schema/console/assessments/create/Category";
import { z } from "zod";

export const formValuesSchema = z.object({
  selectedCategory: z.string(),
  categories: z
    .array(categorySchema)
    .min(1, "Please add at least one category."),
});

export type FormValues = z.infer<typeof formValuesSchema>;
